import React__default from 'react';
import { MiniArticleListNewsList } from './components/mini-article-list-news-list.esm.js';
import { SectionCardLayout } from '../section-card/section-card-layout.esm.js';

var MiniArticleList = function MiniArticleList(props) {
  var articles = props.articles,
    sectionHeading = props.sectionHeading;
  return articles.length ? /*#__PURE__*/React__default.createElement("div", {
    className: "flex flex-col"
  }, /*#__PURE__*/React__default.createElement(SectionCardLayout, {
    sectionHeading: sectionHeading
  }), /*#__PURE__*/React__default.createElement(MiniArticleListNewsList, {
    articles: articles
  })) : null;
};

export { MiniArticleList };
//# sourceMappingURL=mini-article-list.esm.js.map
